import React from 'react';
import { motion } from 'framer-motion';
import { Users, Wrench, BookOpen, Trophy } from 'lucide-react';
const pillars = [{
  icon: Users,
  title: 'Connect',
  description: 'Bring car people together regardless of what they drive.'
}, {
  icon: Wrench,
  title: 'Preserve',
  description: 'Keep real car culture alive. Hands dirty, hoods up.'
}, {
  icon: BookOpen,
  title: 'Share',
  description: 'Knowledge belongs to everyone. No gatekeeping here.'
}, {
  icon: Trophy,
  title: 'Celebrate',
  description: 'Every project matters. From barn finds to show cars.'
}];
export function Mission() {
  return <section className="py-24 bg-garage-bg relative border-t border-garage-border/30" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-garage-text mb-4" data-id="element-123">
            WHAT WE'RE ABOUT
          </h2>
          <div className="h-1 w-24 bg-garage-accent mx-auto" data-id="element-124" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-125">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-garage-surface p-8 border border-garage-border hover:border-garage-accent/50 transition-colors group" data-id="element-126">
              <div className="w-12 h-12 bg-garage-card rounded-sm flex items-center justify-center mb-6 group-hover:bg-garage-accent transition-colors" data-id="element-127">
                <pillar.icon className="w-6 h-6 text-garage-accent group-hover:text-black transition-colors" data-id="element-128" />
              </div>
              <h3 className="text-xl font-display font-bold text-garage-text mb-3" data-id="element-129">
                {pillar.title}
              </h3>
              <p className="text-garage-muted leading-relaxed" data-id="element-130">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}